export default function formatConfig(payload) {
    return {
        id: payload.id,
        components: payload.components
    };
}
